import { z } from 'zod';
/** docs section 19 "Custom Fields" — 13 field types, no migration per field. */
export const customFieldEntityTypeSchema = z.enum(['lead', 'contact', 'company', 'opportunity', 'task']);
export const customFieldTypeSchema = z.enum([
    'text',
    'long_text',
    'number',
    'currency',
    'percentage',
    'date',
    'datetime',
    'boolean',
    'dropdown',
    'multi_select',
    'email',
    'phone',
    'url',
]);
const KEY_PATTERN = /^[a-z][a-z0-9_]{1,63}$/;
export const createCustomFieldDefinitionSchema = z.object({
    entityType: customFieldEntityTypeSchema,
    /** Immutable once created (docs/architecture/03 § custom_field_definitions). */
    key: z.string().regex(KEY_PATTERN, 'lower_snake_case, starting with a letter'),
    label: z.string().trim().min(1).max(100),
    fieldType: customFieldTypeSchema,
    options: z.array(z.string().trim().min(1).max(100)).max(100).optional(),
    required: z.boolean().default(false),
    defaultValue: z.unknown().optional(),
    helpText: z.string().trim().max(300).optional(),
    showOnCreate: z.boolean().default(true),
    isFilterable: z.boolean().default(false),
});
export const updateCustomFieldDefinitionSchema = createCustomFieldDefinitionSchema
    .omit({ entityType: true, key: true, fieldType: true })
    .partial();
export const customFieldDefinitionResponseSchema = z.object({
    id: z.string().uuid(),
    entityType: customFieldEntityTypeSchema,
    key: z.string(),
    label: z.string(),
    fieldType: customFieldTypeSchema,
    options: z.array(z.string()).nullable(),
    required: z.boolean(),
    defaultValue: z.unknown().nullable(),
    helpText: z.string().nullable(),
    showOnCreate: z.boolean(),
    isFilterable: z.boolean(),
    position: z.number().int(),
    /** Records of this entity type with a non-null value at this field's key
     * — Admin ▸ Custom fields' "Used in" column (design/orion-crm-design/
     * rendered-html/AdminCustomFields.html). A real count, not a display
     * estimate: `task` always reports 0 since `Task` has no `customFields`
     * column yet (see `CustomFieldsService#usageCount`'s doc comment). */
    usageCount: z.number().int(),
});
export const reorderCustomFieldsSchema = z.object({
    entityType: customFieldEntityTypeSchema,
    orderedIds: z.array(z.string().uuid()).min(1),
});
//# sourceMappingURL=custom-fields.js.map